<template>
    <div :class="['navbar__feature-card', {'navbar__feature-card--is-pink': section.backgroundColor === 'pink'}]">
        <NuxtImg v-if="section.image" :src="section.image" :alt="section.imageAlt" class="navbar__feature-card__image" />
        <div class="navbar__feature-card__content">
            <h3 v-if="section.title" class="navbar__feature-card__title" name="navbar-feature-card-title">{{ section.title }}</h3>
            <p v-if="section.description" class="navbar__feature-card__text" name="navbar-feature-card-description">
                {{ section.description }}
            </p>
            <VJoyLink
                v-if="section.buttonLink && section.buttonText"
                :href="$withLocalePrefix(section.buttonLink)"
                class="navbar__feature-card__link"
                name="navbar-feature-card-link"
            >
                {{ section.buttonText }}
            </VJoyLink>

            <VJoyButton
                v-if="section.buttonLink && section.buttonText"
                :href="$withLocalePrefix(section.buttonLink)"
                variant="main"
                size="medium"
                class="navbar__feature-card__button"
                name="navbar-feature-card-button"
            >
                {{ section.buttonText }}
            </VJoyButton>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type {NavbarSection} from '@navbar-unlogged-types';
    import {VJoyButton, VJoyLink} from '@maltjoy/core-vue';

    defineProps<{
        section: NavbarSection;
    }>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    /* mobile-first */
    .navbar__feature-card {
        background-color: var(--joy-color-primary-10);
        border-radius: var(--joy-core-spacing-6);
        padding: var(--joy-core-spacing-4);
        gap: var(--joy-core-spacing-4);
        text-align: center;
        width: 100%;

        &--is-pink {
            background-color: var(--joy-color-brand-primary-10);
        }

        @include mq.screen_md(min) {
            display: flex;
            flex-direction: row;
            align-items: stretch;
            text-align: left;
            max-width: 365px;
        }

        &__image {
            display: none;

            @include mq.screen_md(min) {
                width: 170px;
                min-height: 170px;
                height: 100%;
                align-self: stretch;
                object-fit: cover;
                display: block;
                flex-shrink: 0;
                border-radius: var(--joy-core-radius-4);
            }
        }

        &__content {
            display: flex;
            flex-direction: column;
            gap: var(--joy-core-spacing-4);
        }

        &__title {
            @include text.getFontBySize(primary-650);

            color: var(--joy-color-neutral-70);
        }

        &__text {
            display: none;
            color: var(--joy-color-neutral-40);
            margin: 0;
            line-height: 1.5;

            @include mq.screen_md(min) {
                display: block;
            }
        }

        &__button.joy-button {
            width: 100%;
            margin-top: auto;

            @include mq.screen_md(min) {
                display: none;
            }
        }

        &__link.joy-link {
            display: none;

            @include mq.screen_md(min) {
                display: block;
                margin-top: auto;
                text-decoration: underline;
                text-underline-offset: 6px;

                @include text.getFontBySize(primary-400);

                font-weight: var(--joy-font-weight-bold);
            }
        }
    }
</style>
